module.exports = __webpack_public_path__ + "static/media/hangman.4ef759b6.png";